import type {PlaceDetails} from '@Components/google-map/google-map.types';
import {useAppSelector} from '@/hooks';

export const useGoogleMapPlace = (): PlaceDetails | undefined => {
  return useAppSelector(({googleMap}) => {
    return googleMap.place;
  });
};
